import React from 'react';
import './index.css';
import App from './App';
import { createRoot } from 'react-dom/client';
import ReactBreakpoints from 'react-breakpoints';

const breakpoints = {
    mobile: 320,
    mobileLandscape: 480,
    tablet: 768,
    tabletLandscape: 1024,
    desktop: 1200,
    desktopLarge: 1500,
    desktopWide: 1920,
};
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <ReactBreakpoints breakpoints={breakpoints}>
        <App tab="home" />
    </ReactBreakpoints>,
);
